import SEO from "components/seo"
import useTranslations from "hooks/useTranslations"
import UkHero from "./Hero"
import UkVideoIntro from "./VideoIntro"
import UkThreats from "./Threats"
import UkCarousel from "./Carousel"
import UkAgeDistribution from "./AgeDistribution"
import UkTestimonials from "./Testimonials"
import UkIntegrations from "./Integrations"
import UkCtaSection from "./CtaSection"

/**
 * The UK schools page, served at /schools on the global build only.
 *
 * Section order follows Essi's Tab 3 spec, which annotates a screenshot of
 * each section of the previous draft with what to do to it.
 *
 * Wall.tsx, CurriculumCoverage.tsx and Faq.tsx are still in this folder but no
 * longer rendered. The first two were marked "remove section" in Tab 3; the
 * FAQ came out on Kaisa's note that its answers describe only one part of the
 * product and had not been checked, with Jasmina's "remove if it's not ready,
 * we can add it later". The coverage table is the only evidence behind the
 * RSHE 2025 claim the copy still makes, so expect it back.
 *
 * Backgrounds alternate mint / black / white so no two adjacent bands share
 * a ground: mint, black, white, mint, white, black, white, black. Mint rather
 * than the schools segment's yellow because the UK sales deck is mint-dominant,
 * and this page has to look like the deck the rep just presented.
 *
 * AgeDistribution sits directly under the carousel because that is where
 * Ellinora and Kaisa asked for it — "above this one: 'We want to make your
 * school the safest school in the UK'", which is the carousel's own heading,
 * and Sergei's "maybe just another section under that one". Moving it is one
 * line here, but note the ground: mint above and black below leaves white as
 * the only option, which is why that chart runs light.
 */
export default function UkSchoolsPage() {
  const { ukSchoolsSeoTitle } = useTranslations()

  return (
    <div>
      <SEO title={ukSchoolsSeoTitle} />
      <UkHero />
      <UkVideoIntro />
      <UkThreats />
      <UkCarousel />
      <UkAgeDistribution />
      <UkTestimonials />
      <UkIntegrations />
      <UkCtaSection />
    </div>
  )
}
